import React from "react";
import Button from "@material-ui/core/Button";
import styles from "./styles";
const BotonBase = (props) => {
  const { onClick = () => {}, type = "", disabled = false } = props;
  const classes = styles();
  return (
    <Button
      onClick={onClick}
      type={type}
      disabled={disabled}
      variant="contained"
      className={classes.primary}
    >
      Entrar
    </Button>
  );
};
export default BotonBase;
